import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { addSeparatorBetweenElements } from '../../../../utils/jsxUtils';
import { SearchComment } from './searchResultComment.types';

type Props = {
  comment: SearchComment;
};

export const SearchResultCommentSubtitle: FC<Props> = ({ comment }) => {
  const items = [];
  let id = 0;
  if (comment.author) {
    items.push(
      <span
        key={(id += 1)}
        className="excerpt_comment__comment__subtitle__author"
        dangerouslySetInnerHTML={{ __html: comment.author }}
      />,
    );
  }
  if (comment.niceSource) {
    items.push(
      <span
        key={(id += 1)}
        className="excerpt_comment__comment__subtitle__author"
        dangerouslySetInnerHTML={{ __html: comment.niceSource }}
      />,
    );
  }
  if (comment.date) {
    items.push(
      <span
        key={(id += 1)}
        dangerouslySetInnerHTML={{ __html: comment.date }}
      />,
    );
  }
  if (comment.score) {
    items.push(
      <span
        key={(id += 1)}
        dangerouslySetInnerHTML={{ __html: String(comment.score) }}
      />,
    );
  }

  return (
    <div className="excerpt_comment__comment__subtitle">
      {addSeparatorBetweenElements(
        items,
        <span>
          {' '}
          <FormattedMessage id="search/components/search-results/commentary/SearchResultCommentSubtitle.tsx/1" />{' '}
        </span>,
      )}
    </div>
  );
};
